<template>
    <li class="order_content__info_item_list_item">
    <div class="order_content__info_item_list_modifier">
        <div class="order_content__info_item_list_modifier_name">
            {{ nameItem }}
        </div>
        <div class="order_content__info_item_list_modifier_price">
            {{ priceItem }}
        </div>
    </div>
    </li>
</template>

<script>
import formatNumber from "../../../mixins/formatNumber";
import {createHelpers} from "vuex-map-fields";
const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})

export default {
    name: "order_content_info_item_modifier_list",
    props: {
        item: {
            type: Object,
            required: true,
        },
        currencyUser: {
            type: String,
            required: true,
        },
    },
    mixins: [formatNumber],
    computed: {
        ...mUser([
            'user',
        ]),
        nameItem() {
            if (this.item.qty && this.item.title) {
                return this.item.qty + ' X ' + this.item.title;
            }
            return '';
        },
        priceItem() {
            if (this.item.price && this.user.locale) {
                return this.toCurrency(parseFloat(this.item.price), this.currencyUser, 'uk-UA', 2);
            }
            return '';
        },
    },
}
</script>
